module.exports = __webpack_public_path__ + "img/pawel-czerwinski-zBTYRFCeaS0-unsplash.18b515a5.jpg";